import {
  Component,
  AfterContentInit,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { ActivatedRoute } from '@angular/router';

import {
  ProcedureDTO,
  DossierDTO,
  getSimpleIdentifier,
  getSimpleIdentifierFromString,
  DocumentDTO
} from '../../api/plyca-dtos';
import { ServiceLocator } from '../../ServiceLocator';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { AuditComponent } from '../audit/audit.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TreeNode, MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { procedureComponent } from '../../dossiers/procedures/procedure.component';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { PropertyService } from '../../properties/property.service';
import { TaskAssignmentComponent } from '../../tasks/taskAssignment/component/taskAssignment.component';
import { TaskAssignmentComponentConfig } from '../../tasks/taskAssignment/model/taskAssignment.model';
import { UserService } from '../../user.service';
import { ActionDefinitionDTO } from '../../api/plyca-dtos-v2';
import { ProfileService } from '../../../services/profile.services';
import { AppConfiguration } from '../../conf/app.configuration';
import { Observable, forkJoin } from 'rxjs';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { MANUALPROCESSINGMODE_ID, ProcedureCircuitComponent } from '../../dossiers/procedures/procedureCircuit.component';
import { TreeTable } from 'primeng-lts/treetable';




@Component({
  selector: 'procedures',
  templateUrl: 'procedures.template.html',
  providers: [DialogService]
})
export class proceduresComponent extends BaseComponent implements AfterContentInit, OnInit, OnDestroy, AfterViewInit {
  proceduresTreeTable: TreeTable;
  private uiService: UIService;
  private hasReassignProfile = false;

  procedures: ProcedureDTO[];
  dossier: any;

  dossierId = 'Sin Información';

  filteredProcedures: ProcedureDTO[];
  groupedInfo: Array<TreeNode>;

  loaded = false;

  textFilter = '';

  chartTopField = 'status';
  chartTopLabels: string[] = [];
  chartTopData: number[] = [];
  chartTopType = 'doughnut';

  private appConfig: AppConfiguration;
  canCreateProcedure = false;
  canOtherProcedures = false;
  canFinalizationTerminationProcedure = false;

  lastPageFirstRecordIndex = 0;
  defaultNumberRows = 15;
  proceduresbuttonsActionnewvisible = false;

  constructor(
    public plycaService: PlycaDataService,
    route: ActivatedRoute,
    public helpService: HelpService,
    private translate: TranslateService,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private dialogService: DialogService,
    private propertyService: PropertyService,
    private userService: UserService,
    private profileService: ProfileService
  ) {
    super();
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_PROCEDURES));
    this.subscribe(route.params, params => {
      this.dossierId = params['id'];
    });
    this.uiService = ServiceLocator.injector.get(UIService);
    this.waitService.startWaiting();
    // this.subscribe(this.propertyService.getProperty('PERFILES_VALIDOS_REASIGNAR').pipe(
    //   tap((propertyValue: string) => {
    //     let profileList = propertyValue.split(';');
    //     if (this.userService.getUser().hasSignature) {
    //       profileList = profileList.filter((profile: string) => profile.endsWith('A') || profile.endsWith('F'));
    //     } else {
    //       profileList = profileList.filter((profile: string) => profile.endsWith('A') || profile.endsWith('T'));
    //     }
    //     profileList = profileList.map((profile: string) => profile.substring(0, profile.length - 1));
    //     this.hasReassignProfile = profileList.find((profile: string) => this.userService.hasRoles(profile)) !== undefined;
    //     console.log('Reasignacion tiene perfiles ' + this.hasReassignProfile);
    //   })
    // ));
  }
  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    this.load();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
  }


  public isLoaded() {
    return this.loaded;
  }

  loadHeader(): void {
    this.headerActionsService.clearActions();
    this.loadActionsInit();
    this.subscribe(this.headerActionsService
      .addAction('Actualizar', 'fas fa-lg fa-sync-alt', 'btn-primary', true),
      () => {
        this.load();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ),
      () => {
        this.uiService.routeBack();
      });
  }

  initHeader(): Observable<any> {
    return forkJoin([
      // Consultamos el expediente con el flag que nos indica si somos usuario en modo soporte
      // this.propertyService.getProperty('PERFILESCREARMODELO', '0;5'),
      this.plycaService.getAvailableAction('ACTION_OTHER_PROCEDURE', this.dossierId, 'PROJECTENTITY'),
      this.plycaService.getAvailableAction('ACTION_FINALIZATION_TERMINATION_PROCEDURE', this.dossierId, 'PROJECTENTITY'),
    ]).pipe(
      tap(result => {
        /*if (result[0]) {
          let value = result[0];
          value = value.replace(new RegExp(/[;]/g), ',');
          if (!this.isModalWindow
            && this.userService.hasRoles(value)) {
            this.createModel = true;
          }
        }*/
        if (result[0] && result[0].actions[0]) {
          this.canOtherProcedures = this.canOtherProcedures && result[1].actions[0].enabled;
        } else {
          this.canOtherProcedures = false;
        }
        if (result[1] && result[1].actions[0]) {
          this.canFinalizationTerminationProcedure = this.canFinalizationTerminationProcedure && result[1].actions[0].enabled;
        } else {
          this.canFinalizationTerminationProcedure = false;
        }
      }
      ),
      finalize(() => this.loadHeader())
    )
  }

  loadActionsInit() {
    let createProcedures = this.appConfig.getValue('procedures.buttons.createProcedures.visible');
    if (createProcedures) {
      this.headerActionsService.clearActions();
      if (this.canOtherProcedures) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.otherProcedures',
            'fas fa-1-25x fa-plus',
            'btn-secondary',
            true)
          ,
          () => {
            this.actionOtherProcedure();
          });
      }

      if (this.canFinalizationTerminationProcedure) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.finalizationTermination',
            'fas fa-1-25x fa-plus',
            'btn-secondary',
            true)
          ,
          () => {
            this.actionFinalizationTerminationProcedure();
          });
      }
      if (this.canCreateProcedure) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.newProcedure',
            'fa-1-25x fas fa-plus',
            'btn-secondary',
            true
          ),
          () => {
            this.createProcedure();
          });
      }
    }
  }

  actionOtherProcedure() {
    this.subscribe(this.plycaService.getAction('ACTION_OTHER_PROCEDURE'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = this.dossier;
          config['runAction'] = true;
          config['paramsDef'] = actionDefinition.parametersDefinition;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(
            ref.onClose,
            (result: any) => this.load(true)
            // Recargamos siempre porque el action  si ha ejecutado correctamente hace un close() en processResult (actions.process.component)
            // si devolver parametro alguno, por este motivo se comentana a linea: this.load(result !== undefined && result === 'OK') y se toma
            // como solución recargar siempre.
          );
        }
      }
    });
  }

  actionFinalizationTerminationProcedure() {
    this.subscribe(this.plycaService.getAction('ACTION_FINALIZATION_TERMINATION_PROCEDURE'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = this.dossier;
          config['runAction'] = true;
          config['paramsDef'] = actionDefinition.parametersDefinition;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(
            ref.onClose,
            (result: any) => this.load(true)
            // Recargamos siempre porque el action  si ha ejecutado correctamente hace un close() en processResult (actions.process.component)
            // si devolver parametro alguno, por este motivo se comentana a linea: this.load(result !== undefined && result === 'OK') y se toma
            // como solución recargar siempre.
          );
        }
      }
    });
  }

  // Invocacion al componente para iniciar el circuito de tramitacion de un nuevo documento
  private createProcedure(doc?: DocumentDTO): void {
    let ref: DynamicDialogRef;
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Documents.actions.newProcedure'),
      width: '80%',
      style: { overflow: 'hidden' }
    };
    if (getSimpleIdentifierFromString(this.dossier?.modoTramitacion?.identifier) === MANUALPROCESSINGMODE_ID) {
      config.data = {
        dossierId: this.dossier.identifier,
        document: doc
      };
      ref = this.dialogService.open(ProcedureCircuitComponent, config); // ref = ProcedureDTO
    } else {
      config['dossier'] = this.dossier;
      config['document'] = doc;
      ref = this.dialogService.open(procedureComponent, config); // ref = ProcedureDTO
    }
    this.subscribe(
      ref.onClose,
      (procedure: any) => this.load(procedure !== undefined)
    );
  }

  gotoLastPage(gotoLastPage: boolean) {
    if (gotoLastPage) {
      this.lastPageFirstRecordIndex = 0;
      // Accede al número total de registros del TreeTable
      /*let totalRecords = this.proceduresTreeTable?.totalRecords;
      if (this.groupedInfo?.length) {
        totalRecords = this.groupedInfo?.length;
      }*/

      let totalRecords = this.groupedInfo?.length;
      // Establece el primer índice para la última página

      const totalPages = Math.ceil(totalRecords / this.defaultNumberRows);
      this.lastPageFirstRecordIndex = (totalPages - 1) * this.defaultNumberRows;
    }
  }

  load(gotoLastPage?: boolean) {
    this.loaded = false;
    this.waitService.startWaiting();
    let arrayDeObservables: Observable<any>[] = [];

    if (!this.dossier) {
      let dossierObservable = this.loadDossier();
      arrayDeObservables.push(dossierObservable);
    }
    let loadProceduresObservable = this.loadProcedures(gotoLastPage);
    arrayDeObservables.push(loadProceduresObservable);

    this.subscribe(forkJoin(arrayDeObservables).pipe(
      finalize(() => this.loaded = true)
    ));
  }

  loadProcedures(gotoLastPage?: boolean): Observable<any> {
    let procedures = this.plycaService.getProcedures(this.dossierId, 'expansionSet:WEB_CLIENT');
    procedures = procedures.pipe(
      tap((param: PaginationDTO<ProcedureDTO>) => {
        if (param != null && param.content) {
          this.procedures = param.content;
        }
        this.filteredProcedures = this.procedures;
        this.groupInfo();
        this.loadCharts();
        this.waitService.cancelWaiting();
      }),
      finalize(() => {
        this.gotoLastPage(gotoLastPage)
      }));
    return procedures;
  }

  loadDossier(): Observable<any> {
    let dossierObservable = this.plycaService.getDossier(this.dossierId).pipe(
      tap((param: any) => {
        this.dossier = param;

        let profileCreateProcedure = this.appConfig.getValue('documents.createProcedure.profiles');
        this.canCreateProcedure = this.dossier.userAllowedForSupport && (!profileCreateProcedure
          || this.userService.hasRoles(profileCreateProcedure, this.dossier.division.documentClass.application));

        let profileFinalizationProcedures = this.appConfig.getValue('documents.finalizationProcedures.profiles');
        this.canFinalizationTerminationProcedure = !profileFinalizationProcedures ||
          this.userService.hasRoles(profileFinalizationProcedures, this.dossier.division.documentClass.application);

        let profileOtherProcedures = this.appConfig.getValue('documents.otherProcedure.profiles');
        this.canOtherProcedures = !profileOtherProcedures ||
          this.userService.hasRoles(profileOtherProcedures, this.dossier.division.documentClass.application);
      }),
      switchMap(() => this.initHeader())
    );

    return dossierObservable;
  }

  loadCharts(): void {
    this.groupInfo();
    // UPDATE CHARTS
    if (this.filteredProcedures && this.filteredProcedures.length > 0) {
      this.chartTopLabels = [];
      this.chartTopData = [];
      this.filteredProcedures.forEach(this.clasifica, this);
    } else {
      this.chartTopLabels = ['Sin datos'];
      this.chartTopData = [1];
    }
  }

  public clasifica(t: ProcedureDTO) {
    this.tmp(t, this.chartTopField, this.chartTopLabels, this.chartTopData);
    //   this.tmpEstado( t, this.chartBottomField, this.chartBottomLabels, this.chartBottomData );
  }

  private tmp(element: ProcedureDTO, field: string, labels: any, data: any) {
    if (element[field]) {
      let tipo: string = element[field];
      tipo = this.traduce1(tipo);
      let idx: number = labels.indexOf(tipo);
      if (idx === -1) {
        idx = labels.length;
        labels[idx] = tipo;
      }

      let num: number = data[idx];
      if (!num) {
        num = 0;
      }
      data[idx] = ++num;
    }
  }


  traduce1(estado: any) {
    // No debemos utilizar el ===
    let texto = 'otro';
    if (estado == 0) {
      texto = 'Trámite activo';
    } else if (estado == 1) {
      texto = 'Trámite erroneo';
    } else if (estado == 2) {
      texto = 'Trámite finalizado';
    } else if (estado == 3) {
      texto = 'Trámite pausado';
    } else if (estado == 4) {
      texto = 'Trámite cancelado';
    } else if (estado == 5) {
      texto = 'Trámite sin conexión';
    }
    return texto;
  }

  public updateFilter() {

    let _searchText = this.textFilter;
    this.filteredProcedures = this.procedures.filter(function (d: any) {
      /*  let elementExpeId = d.dossier.expedienteId;
               if ( !elementExpeId ) {
                   elementExpeId = '';
               }

               let descExpte = '';
               if ( d.dossier.division )  {
                   descExpte = d.dossier.division.description;
               }*/

      return (
        d &&
        (d?.description?.toLowerCase().indexOf(_searchText?.toLowerCase()) !==
          -1 ||
          !_searchText)
      );
      /*( elementExpeId.toLowerCase().indexOf( val.toLowerCase() ) !== -1 || !val ) ||
              ||
                ( descExpte.toLowerCase().indexOf( val.toLowerCase() ) !== -1 || !val );*/
    });
    this.loadCharts();
  }

  public chartClickedTopChart(): void {
    // let val = this.chartTopLabels[e.active[0]._index];
    // this.filteredelements = this.filteredelements.filter
    //     ( a => ( this.traduce( a.type ) === this.chartTopLabels[e.active[0]._index] ) );
    // if ( this.filteredelements.length > 0 ) {
    //     this.loadCharts();
    // } else {
    //     console.log( "Se limpian los filtros por error de datos ..." );
    //     this.filteredelements = this.elements;
    // }
  }

  public chartClickedBottomChart(): void {
    // this.filteredelements = this.filteredelements.filter
    //     ( a => ( this.traduceEstado( a.status ) === this.chartBottomLabels[e.active[0]._index] ) );
    // if ( this.filteredelements.length > 0 ) {
    //     this.loadCharts();
    // } else {
    //     console.log( "Se limpian los filtros por error de datos ..." );
    //     this.filteredelements = this.elements;
    // }
  }

  public chartTopHovered(): void {
    //      console.log(e);
  }

  public chartBottomHovered(): void {
    //      console.log(e);
  }

  getStatusIcon(estado: any) {

    let texto = 'otro';
    /*
         0    Trámite Activo
        1   Trámite Erroneo
        2   Trámite Finalizado
        3   Trámite Pausado
        4   Trámite Cancelado
        5   Trámite Sin Conexión
         */

    // No se debe utilizar el ====
    if (estado == 0) {
      texto = 'fa-play  text-success';
    } else if (estado == 1) {
      texto = 'fa-times text-danger';
    } else if (estado == 2) {
      texto = 'fas fa-square  text-muted';
    } else if (estado == 3) {
      texto = 'fa-pause text-warning';
    } else if (estado == 4) {
      texto = 'fa-ban text-danger';
    } else if (estado == 5) {
      texto = 'fa-unlink text-danger';
    } return texto;
  }

  getStatusActive(estado: string) {
    let texto = 'otro';
    /*
         0    Trámite Activo
        1   Trámite Erroneo
        2   Trámite Finalizado
        3   Trámite Pausado
        4   Trámite Cancelado
        5   Trámite Sin Conexión
         */
    if (estado === '0') { texto = 'font-weight-bold'; }
    /* Se elima el color del texto, se deja solo en el icono
    else if (estado == '1') { texto = 'font-weight-bold text-danger'; }
    // else if (estado == '2') texto = 'text-muted';
    else if (estado == '3') { texto = 'font-weight-bold text-warning'; }
    else if (estado == '4') { texto = 'font-weight-bold text-danger'; }
    else if (estado == '5') { texto = 'font-weight-bold text-danger'; }
  */
    return texto;
  }



  groupInfo() {
    this.groupedInfo = [];
    if (this.filteredProcedures) {
      this.groupedInfo = this.filteredProcedures.map(x =>
        this.convertprocedures2Node(x)
      );
    }
  }

  convertprocedures2Node(ou: ProcedureDTO): TreeNode {
    let nodo: TreeNode = {};
    nodo.label = ou.description;
    nodo.data = ou;
    if (ou.children) {
      nodo.children = ou.children.map(x => this.convertprocedures2Node(x));
    }

    return nodo;
  }


  existData(): boolean {
    return this.procedures && this.procedures.length > 0;
    //return true;

  }
  showAudit(procedure: ProcedureDTO) {
    let config: DynamicDialogConfig = {
      header: 'Mostrar auditoría',
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '80%', 'min-height': '180px' }

    };
    config['id'] = procedure.division.project.identifier;
    config['procedureId'] = this.getProcedureIdentifier(procedure.identifier);

    const ref = this.dialogService.open(AuditComponent, config);
    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    this.subscribe(ref.onClose,
      () => {
        this.subscribe(this.helpService.showContextHelpObservable(curentHelpTags));
      });
  }

  public getProcedureIdentifier(identifier: any): string {
    return getSimpleIdentifier(identifier);
  }

  public getProcMenuItem(dto: ProcedureDTO): MenuItem[] {

    let items: MenuItem[] = [];

    let mn: MenuItem = {};

    mn = <MenuItem>{};
    mn.label = this.translate.instant('Audit.action');
    mn.title = this.translate.instant('Audit.action');
    mn.icon = 'fas fa-tasks';
    mn.command = (event: Event) => {
      this.showAudit(dto);
    };
    items.push(mn);
    this.subscribe(this.profileService.isReassignmentEnabled(dto),
      (enabled: boolean) => {
        if (enabled) {
          if (enabled) {
            let menuAssignment = {} as MenuItem;
            let dossier = this.dossier;
            menuAssignment.label = this.translate.instant('TaskAssignment.title');
            menuAssignment.title = this.translate.instant('TaskAssignment.title');
            menuAssignment.icon = 'fas fa-briefcase';
            menuAssignment.command = (event: Event) => {
              this.openAssignment(dto, dossier);
            };
            items.push(menuAssignment);
          }
        }
      }
    );
    return items;
  }

  private openAssignment(dto: ProcedureDTO, dossier: DossierDTO): void {
    let taskConfig = new TaskAssignmentComponentConfig();
    taskConfig.procedure = dto;
    taskConfig.project = dossier;
    let config: DynamicDialogConfig = {
      header: this.translate.instant('TaskAssignment.title'),
      width: '80%',
      data: taskConfig
    };
    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    const ref = this.dialogService.open(TaskAssignmentComponent, config)
    this.subscribe(ref.onClose,
      () => {
        this.subscribe(this.helpService.showContextHelpObservable(curentHelpTags));
      });
  }

  public getProcedureDescription(dto: ProcedureDTO): string {
    let result = dto.description;
    if (dto && dto.startInfo && dto.startInfo.comment) {
      result += '. ' + dto.startInfo.comment;
    }
    return result;
  }
}
